/* RUSHOUR Drop (Drop 02, 24.10.2026): Uhr und Zaehler der Drop-Leiste, Phasenwechsel ohne Neuladen,
   Drop-Hinweis auf der Produktseite.
   Konfiguration und erste Phase: snippets/rushour-drop-phase.liquid (window.RH_DROP).
   Uhr nach Serverzeit (Date-Header der Zaehler-Abfrage), damit falsch gestellte Handys richtig zaehlen. */
(function () {
  var C = window.RH_DROP;
  if (!C) return;
  var root = document.documentElement;
  var PHASES = ['pre', 'preview', 'live', 'over'];
  var current = null;
  var lastFetch = 0;
  var left = null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function hhmmss(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000));
    return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
  }
  function mmss(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000));
    return pad(Math.floor(s / 60)) + ':' + pad(s % 60);
  }
  function all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  function setPhase(p, now) {
    if (p !== current) {
      PHASES.forEach(function (x) { root.classList.toggle('rh-ph-' + x, x === p); });
      root.classList.toggle('rh-drop-live', p === 'live');
      current = p;
      lastFetch = 0;
    }
    var strip = p === 'preview' || p === 'live' || (p === 'over' && now < C.end + C.stripAfterH * 3600000);
    root.classList.toggle('rh-strip-on', strip);
    // Last call (Finn 25.10.2026): ab Drop-Ende bis custom.lastcall_ende
    root.classList.toggle('rh-lc', !!(C.lastCall && C.lastCall(now)));
  }

  function zaehlen() {
    var t0 = Date.now();
    fetch('/collections/' + encodeURIComponent(C.collection) + '/products.json?limit=250', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        var d = Date.parse(r.headers.get('date') || '');
        var t1 = Date.now();
        // Nur bei echter Abweichung korrigieren; der Date-Header hat Sekunden-Aufloesung.
        if (!isNaN(d) && !C.test) {
          var off = d + 500 - (t0 + t1) / 2;
          C.serverOffset = Math.abs(off) > 3000 ? off : 0;
        }
        return r.ok ? r.json() : null;
      })
      .then(function (d) {
        if (!d || !d.products) return;
        var total = d.products.length;
        left = d.products.filter(function (p) {
          return p.variants.some(function (v) { return v.available; });
        }).length;
        all('[data-rh-left]').forEach(function (el) { el.textContent = left; });
        all('[data-rh-left-wrap]').forEach(function (el) { el.hidden = !total; });
        all('[data-rh-left-text]').forEach(function (el) {
          if (current === 'over') return;   // ab 7 PM fester Text (Last call), Kollektion hat dann nur noch Verkaufte
          el.textContent = !total ? 'Last pieces' : left ? left + (left === 1 ? ' piece' : ' pieces') + ' left' : 'All sold';
        });
        // Kollektionsseite (rushour-collection.js) markiert damit frisch verkaufte Karten, ohne eigene Abfrage.
        document.dispatchEvent(new CustomEvent('rh:drop-data', { detail: { products: d.products, phase: current } }));
      })
      .catch(function () {});
  }

  function tick() {
    var now = C.now();
    var p = C.phase(now);
    setPhase(p, now);

    var clock = p === 'preview' ? hhmmss(C.start - now) : p === 'live' ? mmss(C.end - now) : p === 'over' ? 'Over' : '';
    all('[data-rh-clock]').forEach(function (el) { if (el.textContent !== clock) el.textContent = clock; });

    // Zaehler: live alle 20 s, sonst alle 2 Min.
    var every = p === 'live' ? 20000 : 120000;
    if (p !== 'pre' && Date.now() - lastFetch > every) { lastFetch = Date.now(); zaehlen(); }

    // Drop-Hinweis auf der Produktseite (snippets/rushour-drop-note)
    all('[data-rh-drop-note]').forEach(function (n) {
      n.hidden = p === 'over';
      var t = n.querySelector('[data-rh-drop-note-text]');
      if (t) t.textContent = p === 'live' ? 'Drop price · ends in ' + mmss(C.end - now) : 'Drop price · until 7 PM';
    });
  }

  // Kaufsperre der Preview entfaellt seit 25.10.2026: Early Access 17-18 Uhr, Kaufen geht (Finn).

  tick();
  setInterval(tick, 1000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { lastFetch = 0; tick(); } });
})();
